import localeStrings from './localeStrings';
import countriesByName from 'country-json/src/country-by-name.json';

const globalConfig = {
  BRAIN_TREE_AUTHTOKEN: process.env.REACT_APP_BRAINTREE_AUTH_TOKEN || '',

  OKTA_AUTH_BASE_URL: process.env.REACT_APP_OKTA_AUTH_BASE_URL || '',
  OKTA_AUTH_CLIENT_ID: process.env.REACT_APP_OKTA_AUTH_CLIENT_ID || '',
  OKTA_AUTH_REDIRECT_URI: process.env.REACT_APP_OKTA_AUTH_REDIRECT_URI || '',
  OKTA_AUTH_ISSUER: process.env.REACT_APP_OKTA_AUTH_ISSUER || '',
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
  RECAPTCHA_RESPONSE_COOKIE_NAME: process.env.REACT_APP_RECAPTCHA_RESPONSE_COOKIE_NAME || '',
  REACT_APP_RECAPTCHA_SKIP_VALIDATION: 'true' === process.env.REACT_APP_RECAPTCHA_SKIP_VALIDATION,
  PAYPAL_ENVIRONMENT: process.env.REACT_APP_PAYPAL_ENVIRONMENT,
  PAYPAL_CREATE_PAYMENT_URL: process.env.REACT_APP_PAYPAL_CREATE_PAYMENT_URL,
  PAYPAL_EXECUTE_PAYMENT_URL: process.env.REACT_APP_PAYPAL_EXECUTE_PAYMENT_URL,
  NO_PAYPAL_MODE: 'false' !== process.env.REACT_APP_NO_PAYPAL_MODE,

  // no corresponding config value so far
  DEBOUNCE_MAX_WAIT: process.env.REACT_APP_DEBOUNCE_MAX_WAIT || 500,
  PAYPAL_CHECK_PAYMENT_URL: process.env.PAYPAL_CHECK_PAYMENT_URL || '/api/payment/check'
};

export { globalConfig, localeStrings, countriesByName };



// WEBPACK FOOTER //
// ./src/applicationConfig/index.js